import styled from "styled-components";
import {
  colors,
  spacing,
  radius,
  textStyles,
  toCSS
} from "design-system/foundation";
import { breakpoints } from "styles";

export const TutorialContainer = styled.div`
  &,
  & *,
  & *::before,
  & *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  gap: ${spacing["5xl"]};
  padding: ${spacing.none} ${spacing["2xl"]};

  @media ${breakpoints.tablet} {
    padding: ${spacing.none};
  }
`;

export const TutorialTitle = styled.p`
  margin: ${spacing.none};
  ${toCSS(textStyles.caption.caption6)};
  color: ${colors.text.base.primary};
  text-align: center;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing["2xl"]};
`;

export const StepTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.md};
`;

export const StepBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: ${spacing.xs} ${spacing.lg};
  background: ${colors.bg.brand.primaryBold};
  border-radius: ${radius.xs};
  ${toCSS(textStyles.caption.caption7)};
  color: ${colors.branding.secondary};
`;

export const StepTitle = styled.h3`
  margin: ${spacing.none};
  ${toCSS(textStyles.heading.h6)};
  color: ${colors.text.base.primary};
  text-align: center;
`;

export const StepImage = styled.img`
  width: 256px;
  height: 256px;
`;

export const MobileOnly = styled.span`
  display: inline;
  @media ${breakpoints.tablet} {
    display: none;
  }
`;

export const DesktopOnly = styled.span`
  display: none;
  @media ${breakpoints.tablet} {
    display: inline;
  }
`;
